const getDomain = () => {
	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'dev')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'develop')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'development')){
			return "https://toolchain-operator-dev.vechaindev.com/operatorapi"
	}

	if(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'test' ||
	(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'newtest')
	){
		return "https://toolchain-workspace.vechaintest.com/operatorapi"
	}
	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'staging') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'stag') ){
		return "https://toolchain-operator-deploy.vtho.net/operatorapi"
	}

	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'product') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'prod') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'production') ){
		return "https://workspace.vetoolchain.cn/operatorapi"
	}
}

const getCookieDomain = () => {
	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'dev')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'develop')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'development')){
			return ".vechaindev.com"
	}

	if(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'test' ||
	(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'newtest')
	){
		return ".vechaintest.com"
	}
	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'staging') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'stag') ){
		return ".vtho.net"
	}

	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'product') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'prod') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'production') ){
		return ".vetoolchain.cn"
	}
}

const getVtrustDomain = () => {
	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'dev')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'test')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'newtest')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'staging') 
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'stag') 
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'develop')
		|| (process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'development')){
			return {
				serviceID: '15600000-0000-0170-0BCC005CA68C74E2',
				baseURL: 'https://vtrust-api.vevid.dev',
				adminURL: 'https://vtrust.vevid.dev',
				landingPageURL: 'https://landing.vevid.dev',
			}
	}

	if((process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'product') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'prod') ||
		(process.env.NODE_ENV && process.env.NODE_ENV.toLowerCase() === 'production') ){
			return {
				serviceID: '15600000-0000-1CC6-DF1B009747D0521C',
				baseURL: 'https://vtrust-api.vetoolchain.cn',
				adminURL: 'https://vtrust.vetoolchain.cn',
				landingPageURL: 'https://vtrust.vechain.com',
			}
	}
}

export default {getDomain, getCookieDomain, getVtrustDomain}